<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <v-card-title class="d-flex">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pt-2">
        <div>
          <v-row>
            <template v-for="(item, key) in details">
              <v-col cols="6" :key="'col-left' + key">
                {{ key }}
              </v-col>
              <v-col cols="6" class="font-weight-bold" :key="'col-right' + key">
                {{ item }}
              </v-col>
            </template>
          </v-row>
        </div>
        <v-btn text class="mt-5" dark color="red" block @click="close()"
          >close</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    type: String,
  },
  data() {
    return {
      dialog: false,
      item: {},
      details: {},
      res: {},
    };
  },
  computed: {
    title() {
      let type = this.type;
      if (type == "bb") return "Broadband Customer Info";
      if (type == "eb") return "Electricity Customer Info";
      if (type == "gb") return "Gas Customer Info";
      if (type == "wb") return "Water Customer Info";
      if (type == "dth") return "DTH Customer Info";
      return "Customer Info";
    },
  },
  methods: {
    getProvider(temps) {
      let operatorname = temps;
      switch (temps) {
        case "AirtelDTH":
          operatorname = "Airteldth";
          break;
        case "DishTV":
          operatorname = "Dishtv";
          break;
        case "SunDirect":
          operatorname = "Sundirect";
          break;
        case "TataSky":
          operatorname = "TataSky";
          break;
        case "VideoconD2H":
          operatorname = "Videocon";
          break;
      }
      return operatorname;
    },
    submit() {
      this.dialog = false;
      this.$emit("continue");
    },
    async init() {
      const vm = this;
      let { provider, phone } = vm.$parent.form;
      vm.$parent.form.customer_name = "";
      vm.$parent.form.amount = "";
      vm.$parent.due_date = "";
      if (!phone) {
        vm.$alert.show("Please enter the service number");
        return;
      }
      let isProvider =
        provider instanceof Object == false || provider.Mplan_Code == undefined;
      if (isProvider) {
        vm.$alert.show("Please select the provider");
        return;
      }
      let operator = provider.Mplan_Code;
      if (vm.type == "dth") {
        operator = vm.getProvider(provider.Service);
      }
      try {
        vm.$loader.show();
        let data = await vm.$store.dispatch("fetchBill", {
          offer: "roffer",
          tel: phone,
          type: vm.type,
          operator,
        });
        vm.details["Operator"] = data.operator;
        vm.details["Service Number"] = data.tel;
        if (data.status == "1") {
          let { records } = data;
          if (records instanceof Array) {
            let item = records[0];
            vm.item = item;
            if (vm.type == "dth") {
              vm.details["Name"] = item.customerName;
              vm.details["MonthlyRecharge"] = item.Balance;
              vm.details["Balance"] = item.Balance;
              vm.details["Plan Name"] = item.planname;
              vm.details["Status"] = item.status;
              vm.details["NextRecharge Date"] = item.NextRechargeDate;
            } else {
              vm.details["Name"] = item.CustomerName;
              vm.details["Bill Amount"] = item.Billamount;
              vm.details["Bill Date"] = item.Billdate;
              vm.details["Due Date"] = item.Duedate;
            }
            if (records[0].status == 0) {
              vm.$alert.show(records[0].desc);
            } else {
              vm.dialog = true;
            }
          } else {
            vm.$alert.show(records.desc);
          }
        } else {
          vm.$alert.show("Customer info not available");
        }
        vm.$loader.hide();
      } catch (error) {
        console.log(error);
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    close() {
      const vm = this;
      vm.dialog = false;
      if (vm.type == "dth") return;
      vm.$parent.form.customer_name = vm.item.CustomerName;
      vm.$parent.form.amount = vm.item.Billamount;
      if (vm.item.Duedate != null) {
        vm.$parent.due_date = vm.item.Duedate;
      }
    },
  },
};
</script>

<style>
</style>